module.exports = __webpack_public_path__ + "static/how-we-do-img-2350f89c5f943a23b879a2fa68de4a4b.png";